import { frontendURL } from 'dashboard/helper/URLHelper';
import TaskBoardsIndex from './pages/TaskBoardsIndex.vue';
import TaskBoardView from './pages/TaskBoardView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    name: 'tasks_boards_index',
    component: TaskBoardsIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/tasks/:boardId'),
    name: 'tasks_board_view',
    component: TaskBoardView,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
